import { useMemo } from 'react';
import { getArrayLength, getCanDownloadNode, getCanShareNode } from 'utils';
import { DataRoomNode } from '../models/DataRoomNode';
import useNodes from 'hooks/useNodes';
import useDataRoomNodeAutorized from './useDataRoomNodeAutorized';

export default function useActionPerNodes(nodes: DataRoomNode[]) {
  const { hasAuthorizedActionsForAll, shouldNotManage } =
    useDataRoomNodeAutorized(nodes);

  const { getCopyByNodeType } = useNodes(nodes);

  const selectedLabel = getCopyByNodeType(
    'itemsSelected',
    'foldersSelected',
    'filesSelected',
    getArrayLength(nodes),
  );

  const canDownloadSelected = useMemo(
    () => nodes.some(getCanDownloadNode),
    [nodes],
  );

  const canShareFiles = useMemo(
    () =>
      hasAuthorizedActionsForAll &&
      !shouldNotManage &&
      nodes.every(getCanShareNode),
    [hasAuthorizedActionsForAll, nodes, shouldNotManage],
  );

  return { selectedLabel, canDownloadSelected, canShareFiles };
}
